import Auth from 'uloc-vue-auth'
const http = Auth.Plugin.http
export default http
